<template>
  <div>
    <div class="column">
      <div class="custom_table_filters column">
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterStartDate"
            name="uniquename"
            :placeholder="$t('msg.start_date')"
          ></datepicker>
        </div>
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterEndDate"
            name="uniquename"
            :placeholder="$t('msg.end_date')"
          ></datepicker>
        </div>

        <div class="component_normal_input_block dis_inb main_white_bg">
          <select v-model="statusFilter">
            <option value="all">{{ $tc("msg.all", 1) }}</option>
            <option value="cancelled">{{ $tc("msg.cancelled", 1) }}</option>
            <option value="done">{{ $tc("msg.status_done") }}</option>
            <option value="expired">{{ $tc("msg.status_expired") }}</option>
            <option value="failed">{{ $tc("msg.failed", 1) }}</option>
            <option value="new">{{ $tc("msg.new") }}</option>
            <option value="waiting">{{ $tc("msg.waiting", 1) }}</option>
          </select>
        </div>

        <button
          class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
          @click="applyFilter()"
        >{{$tc("msg.apply_filter",1)}}</button>
        <button
          class="main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper"
          @click="clearFilter()"
        >
          {{ $tc("msg.clear_filter", 1) }}
        </button>
      </div>
    </div>
    <div class="column tal_r">
      <input
        v-model="searchBox"
        class="custom_input_white"
        :placeholder="$t('msg.global_search')"
      />
    </div>
    <div class="column">
      <vue-good-table
        :columns="columns"
        :key="keyTable"
        :rows="redeemsOnPage"
        :select-options="{ enabled: false }"
        :search-options="{
          enabled: true,
          searchFn: customSearch,
          externalQuery: searchBox,
        }"
        ref="historytable"
        :line-numbers="true"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'createdAt', type: 'desc' },
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: '5',
          position: 'down',
          perPageDropdown: [10, 15, 20],
          dropdownAllowAll: false,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'per page',
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
      >
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.label == 'address'">{{
            $t("msg.address")
          }}</span>
          <span v-if="props.column.label == 'txid'">{{ $t("msg.txid") }}</span>
          <span v-if="props.column.label == 'createdAt'">{{
            $t("msg.createdAt")
          }}</span>
          <span v-if="props.column.label == 'updatedAt'">{{
            $t("msg.updatedAt")
          }}</span>
          <span v-if="props.column.label == 'amount'"
            >{{ $t("msg.amount") }} BLUE</span
          >
          <span v-if="props.column.label == 'amountBTC'">{{
            $t("msg.redeemed_value")
          }}</span>
          <span v-if="props.column.label == 'status'">{{
            $t("msg.status")
          }}</span>
          <span v-if="props.column.label == 'actions'">{{
            $t("msg.actions")
          }}</span>
        </template>

        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'targetAddress'">
            {{ props.formattedRow[props.column.field] }}
          </span>
          <span v-if="props.column.field == 'tokenTxid'">
            <span v-if="props.row.status == 'done'">
              <a
                :title="$t('msg.details')"
                :href="
                  'https://bscscan.com/tx/' +
                  props.formattedRow[props.column.field]
                "
                target="blank_"
                >{{ ajustTokenID(props.formattedRow[props.column.field]) }}</a
              >
            </span>
            <span v-else> ---- </span>
          </span>
          <span v-if="props.column.field == 'createdAt'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'updatedAt'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'sourceAmount'">
            <span v-if="props.formattedRow[props.column.field] > 0">{{
              props.formattedRow[props.column.field].toFixed(6)
            }}</span>
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'targetAmount'">
            <span v-if="props.formattedRow[props.column.field] > 0">
              {{ props.formattedRow[props.column.field].toFixed(8) }}
              {{ props.row.targetCurrency.symbol }}
            </span>
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'status'">
            {{ $t("msg.status_" + props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'actions'">
            <div
              class="container_actions"
              v-if="
                props.row.step <= 2 &&
                props.row.status != 'cancelled' &&
                props.row.status != 'expired'
              "
            >
              <!-- <span v-html="iconSets.plus_no_circle" class="icon_class_1 icon_details" ></span> -->
              <span
                v-html="iconSets.trash"
                class="icon_class_1 icon_delete"
                @click="cancelRedeem(props.row.id)"
              ></span>
            </div>
          </span>
        </template>

        <div slot="emptystate">
          <p class="tac">{{ $tc("msg.no_data_found", 1) }}</p>
        </div>
      </vue-good-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
// import moment from 'moment'
import spacetime from "spacetime";

export default {
  created() {
    this.getRedeem();
    // this.tradeTracking(this.tradeTrackType);
  },
  mounted() {},
  data: () => ({
    searchBox: "",
    statusFilter: "all",
    filterStartDateInit: "",
    filterEndDateInit: "",
    filterEndDate: "",
    filterStartDate: "",
    filterEndDate: "",
    redeems: [],
    redeemsOnPage: [],
    tradeTrackType: "redeem",
    lastRedeem: "",
    keyTable: 0,
    columns: [
      {
        label: "address",
        field: "targetAddress",
        filterable: true,
      },
      {
        label: "txid",
        field: "tokenTxid",
        filterable: true,
      },
      {
        label: "createdAt",
        field: "createdAt",
      },
      {
        label: "updatedAt",
        field: "updatedAt",
      },
      {
        label: "amount",
        field: "sourceAmount",
        type: "number",
        filterable: true,
      },
      {
        label: "amountBTC",
        field: "targetAmount",
        type: "number",
        filterable: true,
      },
      {
        label: "status",
        field: "status",
        filterable: true,
      },
      // {
      //   label: "actions",
      //   field: "actions",
      //   filterable: false
      // }
    ],
  }),
  components: {
    Datepicker,
  },
  methods: {
    async getRedeem() {
      try {
        let resp = await this.$store.dispatch("getRedeems");
        this.redeems = resp.data;
        this.redeemsOnPage = this.sortByCreatedAt(this.redeems);
      } catch (e) {
        console.log(e);
      }
    },

    // async tradeTracking(type){
    //   let resp = await this.$store.dispatch('getTradeType', type);
    //   this.lastRedeem = resp.data;
    // },

    findTradeTrack() {
      for (let i = 0; i < this.redeemsOnPage.length; i++) {
        if (this.redeemsOnPage[i].id == this.lastRedeem.tradeId) {
          this.redeemsOnPage[i].step = this.lastRedeem.step;
          break;
        }
      }
    },

    sortByCreatedAt(array) {
      array.sort((a, b) => {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });
      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },

    applyFilter() {
      let startDateOnInput = this.filterStartDate;
      let endDateOnInput = this.filterEndDate;

      let date1 = new Date(startDateOnInput);
      let date2 = new Date(endDateOnInput);

      let startDate = `${date1.getFullYear()}-${
        date1.getMonth() + 1 < 10
          ? "0" + (date1.getMonth() + 1)
          : date1.getMonth() + 1
      }-${
        date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()
      }T00:00:00.000Z`;

      let endDate = `${date2.getFullYear()}-${
        date2.getMonth() + 1 < 10
          ? "0" + (date2.getMonth() + 1)
          : date2.getMonth() + 1
      }-${
        date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate()
      }T23:59:999Z`;

      this.filterRowByDate(startDate, endDate);
    },

    filterRowByDate(startDate, endDate) {
      this.redeemsOnPage = this.redeems;

      this.redeemsOnPage = this.redeemsOnPage.filter((item) => {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.redeemsOnPage = this.redeemsOnPage.filter((item) => {
          return item.status == this.statusFilter;
        });
      }
    },

    clearFilter() {
      let vm = this;
      this.redeemsOnPage = this.redeems;

      this.filterEndDate = this.filterEndDateInit;
      this.filterStartDate = this.filterStartDateInit;

      this.statusFilter = 'all'
    },

    customSearch(row, col, cellValue, searchTerm) {
      let vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;
        return cellValue;
      }
    },

    ajustTokenID(tokenID) {
      let str = tokenID;
      let res = str.substring(0, 15);
      return res + "... [+]";
    },

    async cancelRedeem(id) {
      let self = this;
      if (confirm(this.$t("msg.confirm_delet"))) {
        try {
          let rest = await this.$store.dispatch("putRedeem", id);
          this.notifySuccess(this.$t("msg.redeem_deleted_success"), 5000);
          // self.keyTable = self.keyTable +1;
          self.keyTable = self.keyTable + 1;
          this.getRedeem();
        } catch (e) {
          this.notifyDanger(this.$t("msg.redeem_deleted_error"), 5000);
          console.log(e);
        }
      }
    },

    formatDate(value) {
      return spacetime(value).format("dd/MM/yyyy HH:mm:SS");
    },
  },
  computed: {},
  watch: {
    redeemsOnPage: function () {
      // this.findTradeTrack();
      // this.getRedeem();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/private/transactions/TransactionTableRedeem.vue